import React from 'react'
import styles from './styles.module.scss'

type SwitcherProps = {
  values: string[]
  value: boolean
  handler: () => void
}

export const Switcher: React.FC<SwitcherProps> = ({values, value, handler}) => {
  return (
    <div className={styles.switcher}>
      <div className={`${styles.switcherToggle} ${value ? styles.active : ''}`}>
        {!value ? values[0] : values[1]}
      </div>
      <span className={styles.item} onClick={() => value && handler()}>{values[0]}</span>
      <span className={styles.item} onClick={() => !value && handler()}>{values[1]}</span>
    </div>
  )
}